import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import { useConfig } from '../defaultConfig';
import { MessageInfo } from '../generated-types';
import { getUnreadMessages, getUnreadMessagesWithCustomerDialog } from '../services/messageService';

const useUnreadMessages = (enabled = true): QueryResult<MessageInfo> => {
    const { featureToggles } = useConfig();
    const queryKey = ['messages', featureToggles.enableCustomerDialogue ? 'customer-dialogue' : null].filter(Boolean);
    return useQuery({
        queryKey,
        queryFn: featureToggles.enableCustomerDialogue ? getUnreadMessagesWithCustomerDialog : getUnreadMessages,
        enabled,
    });
};

export default useUnreadMessages;
